import { FormattedMessage } from '@subaio/components'

import { asContainer } from 'lib/container'

import { HeaderIconError } from 'components/Icons'
import { ContentCenter, HeaderIconWrapper, Page, SecondaryText, Title } from 'components/Layout'

export const container = asContainer<{}>()({
	Running: () => (
		<Page>
			<ContentCenter>
				<HeaderIconWrapper>
					<HeaderIconError />
				</HeaderIconWrapper>
				<Title>
					<FormattedMessage id='authExpired.title' defaultMessage='Page expired' />
				</Title>
				<SecondaryText>
					<FormattedMessage
						id='authExpired.text'
						defaultMessage='The page has expired. Please reload it if you wish to continue.'
					/>
				</SecondaryText>
			</ContentCenter>
		</Page>
	),
})
